<oe-flat-widget [modalComponent]="modalComponent" [title]="component?.alias"
  [icon]="{name: 'trending-down-outline', color: 'normal'}">

  <oe-flat-widget-line [name]="'GENERAL.MEASURED_VALUE'| translate" [converter]="CONVERT_WATT_TO_KILOWATT"
    [value]="activePower"></oe-flat-widget-line>
  <oe-flat-widget-line [name]="'EDGE.INDEX.WIDGETS.PEAKSHAVING.PEAKSHAVING_POWER' | translate"
    [converter]="CONVERT_WATT_TO_KILOWATT" [value]="peakShavingPower"></oe-flat-widget-line>
  <oe-flat-widget-line [name]="'EDGE.INDEX.WIDGETS.PEAKSHAVING.RECHARGE_POWER' | translate"
    [converter]="CONVERT_WATT_TO_KILOWATT" [value]="rechargePower"></oe-flat-widget-line>
</oe-flat-widget>
